module.exports = __webpack_public_path__ + "fonts/Courier-Bold.9ee45159.ttf";